<template>
  <div class="exam-header-warp">
    <div class="header-content">
        <div class="left">
        <template v-if="canClickLogo">
          <router-link :to="{name: loginStatus ? 'contentIndex' : 'home'}"><img src="@/common/images/student/logo_header.png" alt=""></router-link>
        </template>
        <img v-else src="@/common/images/student/logo_header.png" alt="">
        <!-- <a href="/competition">
        </a> -->
      </div>
      <div class="right" v-if="loginStatus">
        <slot name="extend"></slot>
        <div class="right-userWrap" v-if="!showDetail">
          <div class="user-img">
            <img class="user-img_img" v-if="userInfo?.isVisitor" src="@/common/images/student/ic_avatar_visitor.png"/>
            <img class="user-img_img" v-else src="@/common/images/student/img_avatar.png"/>
          </div>
          <!-- <div class="user-nick">{{userInfo.userName || '我的'}}</div> -->
          <div class="user-nick">{{userInfo?.isVisitor ? userInfo.visitorName : (userInfo?.username || '我的')}}</div>
          <div class="dropdown-menu">
            <div class="dropdown-item item-switch" @click="logout">切换账号</div>
            <div class="dropdown-item item-logout" @click="logout">退出登录</div>
          </div>
        </div>
        <div class="right-userWrap" v-else-if="userInfo">
          <div class="user-img"><img class="user-img_img" src="@/common/images/student/img_avatar.png"/></div>
          <div class="user-info nick">姓名：{{ userInfo.username }}</div>
          <div class="user-info school">{{ userInfo.schoolName }}</div>
          <div class="user-info idCard">身份证号：{{ userInfo.idCardNo }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { getUserLoginStatus, exitUser } from '@/api/api';
  import { getUser } from '@/api/user';

  export default {
    name: 'examHeader',
    props: {
      showDetail: {
        type: Boolean,
        default: false
      },
      canClickLogo: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        loginStatus: false,
        userInfo: null
      }
    },
    created() {
      this.getUserLoginStatus();
    },
    methods: {
      getUserLoginStatus() {
        getUserLoginStatus().then((res) => {
          if (res.body.login === true) {
            this.loginStatus = true;
            this.updateUserInfo();
          } else {
            this.loginStatus = false;
          }
        });
      },
      updateUserInfo() {
        getUser()
          .then((res) => {
            const isVisitor = !res.roles?.length || !res.roles.includes('STUDENT');
            this.userInfo = {
              ...res,
              // 老师/管理员身份，也展示 我的 字样
              isVisitor,
              visitorName: isVisitor ? `访客${res.userId || ''}` : '',
            };
          })
          .catch((err) => {
            console.error(err);
          });
      },
      logout() {
        localStorage.removeItem('userInfo');
        exitUser();
      },
      handleLogoClick() {
        if (!this.canClickLogo) return;
        this.$router.push({ name: 'home' });
      }
    }
  }
</script>
<style scoped lang="less">
  .exam-header-warp{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    height: 72px;
    background: #ffffff;
    display: flex;
    align-items: stretch;
    .header-content{
      display: flex;
      justify-content: space-between;
      width: 100%;
      // min-width: 1200px;
      padding: 0 5.2%;
      align-items: stretch;
      box-sizing: border-box;
      .left{
        display: flex;
        align-items: center;
        img {
          height: 32px;
        }
      }
      .right{
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        &-link, .user-nick{
          font-size: 16px;
          color: #616161;
          font-weight: 500;
        }
        &-link {
          margin-right: 30px;
        }
        .user-img{
          width: 28px;
          height: 28px;
          border-radius: 50%;
          margin-right: 8px;
        }
        .user-img_img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .right-userWrap {
          display: flex;
          align-items: center;
          position: relative;
          &:hover {
            .dropdown-menu {
              opacity: 1;
              transform: scale(1);
            }
          }
        }
        .dropdown-menu {
          position: absolute;
          top: 40px;
          left: 10px;
          border-radius: 12px;
          opacity: 1;
          background: #FFFFFF;
          box-sizing: border-box;
          border: 1px solid #EDEDEF;
          box-shadow: 6px 6px 32px 0px rgba(39, 43, 141, 0.1);
          padding: 16px 12px;
          opacity: 0;
          transform: scale(0.1);
          transition: all 0.3s;
          transform-origin: 50% top;
        }
        .dropdown-item {
          cursor: pointer;
          border-radius: 8px;
          width: 104px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #86909C;
          &:nth-child(n+2) {
            margin-top: 4px;
          }
          &:hover {
            font-weight: 500;
          }
        }
        .item-switch:hover {
          background: #F5F6F9;
          color: #4E5969;
        }
        .item-logout:hover {
          background: #5B54FC14;
          color: #5B54FC;
        }
        .user-info {
          color: #616161;
          font-size: 16px;
          font-weight: 500;
          &.school {
            margin-left: 30px;
            margin-right: 30px;
          }
        }
      }
    }
  }
</style>
